import {CreateProps,} from "react-admin";
import {ReconciliationFileForm} from "./ReconciliationFileForm";
import {CustomCreate} from "../../components/CustomCreate";


export const ReconciliationFileCreate = (props: CreateProps) => {
    return props ? (
      <CustomCreate {...props}>
        <ReconciliationFileForm/>
      </CustomCreate>
    ) : null;
}